import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
export interface MagazinesItem {
  title: string;
  readPath: string;
  downloadPath: string;
  date: string;
  image: string;
}
export interface MagazinesResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: MagazinesItem[];
}
export const fetchMagazines = async (): Promise<MagazinesResponse> => {
  try {
    const {
      data
    } = await http.get<MagazinesResponse>(API_ENDPOINTS.MAGAZINES);
    return data;
  } catch (error) {
    throw error;
  }
};
export const fetchRecentMagazines = async (): Promise<MagazinesResponse> => {
  try {
    const {
      data
    } = await http.get<MagazinesResponse>(`${API_ENDPOINTS.MAGAZINES}?limit=5`);
    return data;
  } catch (error) {
    throw error;
  }
};
export const useMagazinesQuery = () => {
  return useQuery<MagazinesResponse, Error>('Magazines/Magazines', fetchMagazines, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5
  });
};
export const useRecentMagazinesQuery = () => {
  return useQuery<MagazinesResponse, Error>(['Magazines/Magazines', 'recent'], fetchRecentMagazines, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000
  });
};